export default [
    {
        path: '/calendar',
        name: 'calendar',
        component: () =>
            import ('@/views/pages/calendar/Calendar.vue'),
        meta: {
            pageTitle: 'Calendar',
            breadcrumb: [{
                text: 'Calendar',
                active: true,
            }, ],
            resource: 'home',
        },
    },
]